export default __webpack_public_path__ + "static/0225-79eeb4c0c8009b4653c7018066ce5e62.png";